import React from 'react';
import SingularOrPluralText from '../SingularOrPluralText/SingularOrPluralText';

interface IDistanceProps {
  distanceInMeters?: number;
  unit?: string;
  className?: string;
  decimalPoints?: number;
}

const Distance: React.FC<React.PropsWithChildren<IDistanceProps>> = ({
  distanceInMeters = 0,
  unit,
  className,
  decimalPoints = 1,
}) => {
  const convertedDistance = React.useMemo(() => {
    const inKms = distanceInMeters / 1000;
    let value: any =
      Math.round(((unit === 'miles' && inKms * 0.621371) || inKms) * 100) / 100;

    if (value) {
      value = value.toFixed(decimalPoints);
    }

    unit = unit?.replace(/s\b/, '');

    return (
      <>
        {value} <SingularOrPluralText showWhenZero number={value} text={unit} />
      </>
    );
  }, [distanceInMeters, unit]);

  return <span className={className}>{convertedDistance}</span>;
};
export default Distance;
